export default function userGroupsReducer(state = {
  userGroups: [],
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_USERGROUP_LIST_PENDING':
    case 'GET_USERGROUP_PENDING': {
      return {...state, fetching: true, fetched: false}
    }
    case 'GET_USERGROUP_LIST_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        userGroups: action.payLoad.data,
      }
    }
    case 'GET_USERGROUP_LIST_REJECTED':
    case 'GET_USERGROUP_REJECTED': {
      return {...state, errors: action.payLoad.errors}
    }
    case 'GET_USERGROUP_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        userGroup: action.payLoad.data,
      }
    }
    case 'DELETE_USERGROUP_FULFILLED': {
      const newState = {...state};
      newState.userGroups = newState.userGroups.filter(group => {
        return group.id !== action.payLoad
      });
      return newState;
    }
    default:
  }

  return {...state};
}



// WEBPACK FOOTER //
// ./src/reducers/userGroupsReducer.js